import { render } from "./selfScanCompanies.vue?vue&type=template&id=b5491cf6"
import script from "./selfScanCompanies.vue?vue&type=script&lang=js"
export * from "./selfScanCompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__